<template>
<div :ref="loadingobj">    
    <div class="TTL-el-form-search-regular">
        <span class="TTL-title">编辑运费设置</span>
        <div class="TTL-button TTL-btn-option">
        <el-badge :value="shippinglist.length > 1 ? shippinglist.length : ''" class="item">
        <wcbutton :option="{title:'提交数据'}" @finish="submitData"/>
        </el-badge>
        </div>
        <div class="TTL-button TTL-btn-option">
        <wcbutton :option="{title:'返回设置管理',type:'del'}" @finish="$parent.JUMPVIEW({name:'EsShipping'})"/>
        </div>
    </div>
    
    <div>
        <div class="TTL-form-submit-box " v-for="(item,index) in shippinglist" :key="index">
            <div class="TTL-form-submit-box-title">运费设置-{{index+1}}</div>
            <el-form :inline="false" style="margin-top:20px">
                <el-form-item>
                    <label class="TTL-form-label">运费名称<i>*</i></label>
                    <wcinput :option="{placeholder:'请输入运费名称',type:'input',clearable:true,ischange:true,isinput:true,iskeydown:true,width:'250px'}" 
                        :value="item.name"
                        @finish="(val)=> {
                            if(val.type=='input') {
                                item.name=val.value;
                                
                            }
                            if(val.type=='change') {
                                item.name=val.value;
                                
                            }
                        }"
                    />
                </el-form-item>
                <el-form-item>
                    <label class="TTL-form-label">运费类型<i>*</i></label>
                    <wcselect :option="{placeholder:'配送类型',ischange:true,width:'170px',clearable:true,filterable:true}" 
                        :value="item.type"
                        :list="typelist"
                        @finish="(val)=> {
                            item.type=val.value;
                            
                        }"
                    />
                </el-form-item>
                <el-form-item v-if="item.type==1">
                    <label class="TTL-form-label">距离/重量/体积-金额设置<i>*</i></label>
                    <div class="TTL-setting-info">
                        <span class="TTL-setting-info-title right10">小于等于</span>
                        <wcinputprex :option="{isinput:true,childname:'km',width:'170px'}"
                            :value="item.lowvalue"
                            @finish="(val)=> {
                                item.lowvalue=val.value;
                                
                            }"
                        />
                        <span class="TTL-setting-info-title left10 right10">，</span>
                        <wcinputprex :option="{isinput:true,childname:'元',width:'170px'}"
                            :value="item.price"
                            @finish="(val)=> {
                                item.price=val.value;
                                
                            }"
                        />
                        <span class="TTL-setting-info-title left10 right10">，每增加</span>
                        <wcinputprex :option="{isinput:true,childname:'km',width:'170px'}"
                            :value="item.unitvalue"
                            @finish="(val)=> {
                                item.unitvalue=val.value;
                                
                            }"
                        />
                        <span class="TTL-setting-info-title left10 right10">，金额增加</span>
                        <wcinputprex :option="{isinput:true,childname:'元',width:'170px'}"
                            :value="item.unitprice"
                            @finish="(val)=> {
                                item.unitprice=val.value;
                                
                            }"
                        />
                    </div>
                </el-form-item>
                <el-form-item v-if="item.type==2">
                    <label class="TTL-form-label">距离/重量/体积-金额设置<i>*</i></label>
                    <div class="TTL-setting-info">
                        <span class="TTL-setting-info-title right10">小于等于</span>
                        <wcinputprex :option="{isinput:true,childname:'kg',width:'170px'}"
                            :value="item.lowvalue"
                            @finish="(val)=> {
                                item.lowvalue=val.value;
                                
                            }"
                        />
                        <span class="TTL-setting-info-title left10 right10">，</span>
                        <wcinputprex :option="{isinput:true,childname:'元',width:'170px'}"
                            :value="item.price"
                            @finish="(val)=> {
                                item.price=val.value;
                                
                            }"
                        />
                        <span class="TTL-setting-info-title left10 right10">，每增加</span>
                        <wcinputprex :option="{isinput:true,childname:'kg',width:'170px'}"
                            :value="item.unitvalue"
                            @finish="(val)=> {
                                item.unitvalue=val.value;
                                
                            }"
                        />
                        <span class="TTL-setting-info-title left10 right10">，金额增加</span>
                        <wcinputprex :option="{isinput:true,childname:'元',width:'170px'}"
                            :value="item.unitprice"
                            @finish="(val)=> {
                                item.unitprice=val.value;
                                
                            }"
                        />
                    </div>
                </el-form-item>
                <el-form-item v-if="item.type==3">
                    <label class="TTL-form-label">距离/重量/体积-金额设置<i>*</i></label>
                    <div class="TTL-setting-info">
                        <span class="TTL-setting-info-title right10">小于等于</span>
                        <wcinputprex :option="{isinput:true,childname:'m³',width:'170px'}"
                            :value="item.lowvalue"
                            @finish="(val)=> {
                                item.lowvalue=val.value;
                                
                            }"
                        />
                        <span class="TTL-setting-info-title left10 right10">，</span>
                        <wcinputprex :option="{isinput:true,childname:'元',width:'170px'}"
                            :value="item.price"
                            @finish="(val)=> {
                                item.price=val.value;
                                
                            }"
                        />
                        <span class="TTL-setting-info-title left10 right10">，每增加</span>
                        <wcinputprex :option="{isinput:true,childname:'m³',width:'170px'}"
                            :value="item.unitvalue"
                            @finish="(val)=> {
                                item.unitvalue=val.value;
                                
                            }"
                        />
                        <span class="TTL-setting-info-title left10 right10">，金额增加</span>
                        <wcinputprex :option="{isinput:true,childname:'元',width:'170px'}"
                            :value="item.unitprice"
                            @finish="(val)=> {
                                item.unitprice=val.value;
                                
                            }"
                        />
                    </div>
                </el-form-item>
                

            </el-form>
        </div>
    </div>
</div>
</template>

<script>
import INTERFACE_MODEL_SHIPPING from '@/Interface/Es/shipping';
export default {
    components:{},
    data() {
        return {
            Browser:'editshipping',
            loadingobj:'editshipping',
            limit:10,  //限制添加数据条数
            memberinfo:{name:'',type:1,lowvalue:'',heightvalue:'',price:'',unit:'km',unitvalue:'',unitprice:''}, //设置模板信息           
            shippinglist:[], //续费设置
            typelist:[],

        }
    },
    mounted() {
        this.OnloadMethod(); //页数初始化
    },
    methods: {


        /** 页数初始化 **/
        OnloadMethod(isfresh) {
            this.GetShippingType(isfresh);
        },


        /** 其它组件调用当前组件进行数据传递 **/
        BrotherComponentIn(data) {
            if(data.isask) {  //兄弟组件跳转至当前组件时进行询问操作
                this.$confirm.confirm(
                    '当前有操作正在执行，是否要将其覆盖 ？',
                    '删除提示',
                    {confirmButtonText:'确定',cancelButtonText:'取消',type: 'warning'}
                ).then(()=> {
                    this.GetShippinginfos(data.param.ids);
                }).catch(()=> {

                });
            }else if(data.reload) {  //浏览器重新刷新时执行的操作
                
            }else {
                this.GetShippinginfos(data.param.ids);
            }
        },


        /** 保存模板信息 **/
        submitData() {
            if(this.shippinglist.length==0) {this.$notice({title:'错误提示',message:'请至少填写一个设置',type:'warning'});return false;}
            var data=[];
            for(var i in this.shippinglist) data.push(this.shippinglist[i]);
            data=JSON.stringify(data);

            var obj=this.$refs[this.loadingobj];
            this.$loading.openloading(obj);
            INTERFACE_MODEL_SHIPPING.EDIT_SHIPPING({data:data}).then((res) => {
                this.$loading.closeloading(obj);
                if(res.status > 0) return false;
                this.$notice({title:'成功提示',message:'添加数据成功',type:'success'});
                this.$parent.JUMPVIEW({name:'EsShipping',delname:'EsEditShipping'});
            });
        },


        //////////////////////////////////////////////////////////////////////
        //////////////////////////////////////////////////////////////////////
        //基础数据操作


        /** 获取运费信息数据 **/
        GetShippinginfos(ids) {
            INTERFACE_MODEL_SHIPPING.GET_SHIPPING_INFO({ids:ids}).then((res) => {
                if(res.status > 0) return false;
                this.shippinglist=res.data;
            });
        },


         /** 获取运费类型 **/
        GetShippingType(isfresh) {
            this.$method.GET_SHIPPING_TYPE(isfresh).then((res) => {this.typelist=res;console.log(res)});
        },


    },
}
</script>
<style scoped>
.TTL-image-box-large {cursor: pointer;width:auto !important;}
.TTL-image-box-large .el-image {width:100px;height:100px;display: inline-block;border-radius: 15px;background-color: #EBEDF0;}
.imagefile {display:inline-flex !important;justify-content: center !important;align-items:center !important;}
::v-deep(.imagefile .el-image__inner) {width:50% !important;height: 50% !important;}

.TTL-image-box-large span {display: inline-block;font-size:12px;margin-left:20px;color:#f56c6c;}
.TTL-btn-option {display:inline-block;margin-right:20px;}
::v-deep(.TTL-radio .el-radio__label) {display: inline-flex !important;align-items: center !important;}
.TTL-radio .el-image {width:18px;height: 18px;}
.petTitle {padding:30px 0 20px 0;}
.TTL-photos {display:inline-block;width:100%;font-size:0;}
.TTL-photos-infos {display:inline-block;width:100px;height:100px;margin-right:10px;margin-bottom:10px;background-color:#e6e7ec;border-radius: 15px;overflow:hidden;position:relative;}
.TTL-photos-infos .el-image {width:100%;height:100%;}
.TTL-photos-del {width:25px;height:25px;position: absolute;top:0;right:0;margin-top:5px;margin-right:5px;border-radius: 50%;background-color: rgba(0,0,0,1);display:inline-flex;justify-content: center;align-items: center;background-image:url(@/assets/icon/close.png);background-repeat: no-repeat;background-size:8px;background-position: center;}
.default-photos {background-image:url(@/assets/icon/default-img.png);background-repeat: no-repeat;background-size: 65%;background-position: center;cursor: pointer;}
.TTL-photos-select {width:25px;height:25px;position: absolute;bottom:0;right:0;margin-bottom:5px;margin-right:5px;border-radius: 50%;background-color:#666eeb;display:inline-flex;justify-content: center;align-items: center;background-image:url(@/assets/icon/right.png);background-repeat: no-repeat;background-size:8px;background-position: center;}
.TTL-photos-select-no {width:25px;height:25px;position: absolute;bottom:0;right:0;margin-bottom:5px;margin-right:5px;border-radius: 50%;background-color:rgba(221,221,221,.6);display:inline-flex;justify-content: center;align-items: center;background-image:url(@/assets/icon/right.png);background-repeat: no-repeat;background-size:8px;background-position: center;}
.TTL-form-label i {font-style:normal;color:red;font-size:12px;font-weight: 400;}
.fileup {background-color: #666eeb !important;}
::v-deep(.fileup .el-image__inner) {width:80% !important;height: 80% !important;}
.TTL-setting-info {display: inline-flex;width:100%;align-items: center;}
.TTL-setting-info-title {font-size:13px;}
</style>